import React from "react";
import Commnuity from "./Community";
import Infos from "./Infos";
import Copyright from "./Copyright";

const Footer = () => {
  return (
    <div>
      <Commnuity />
      <Infos />
      <Copyright />
    </div>
  );
};

export default Footer;
